'use strict';

const translateCountry = require('../../../custom_components/js/country-translator');

window.ADDRESS_SELECTED_EVENT = 'address_selected';

module.exports = /* @ngInject */ function() {
    return {
        restrict: 'E',
        scope: {
            /**
             * Currently only "SHIPPING" is supported. "INVOICE" will be implemented later
             */
            addressType: '@',
        },
        templateUrl: `./${BUILD_PATH}/address-selection.directive.html`,
        controller: /* @ngInject */ function ($scope, $element, addressService, userService) {

            const SHIPPING_TYPE = 'SHIPPING';

            let addresses;
            $scope.filteredAddresses = null;
            $scope.fullListLength = null;
            $scope.searchQuery = '';
            $scope.filter = filter;

            $scope.selectAddress = selectAddress;

            init();

            async function init(){
                $scope.user = await userService.getMyself.get().$promise
                if($scope.addressType === SHIPPING_TYPE) {
                    addressService.getAllShipping().then((addressResponse) => {
                        addresses = addressResponse;
                        $scope.fullListLength = addresses.length;
                        filter();
                    })
                }
            }

            function filter(query = '') {
                $scope.filteredAddresses = addresses.filter((address) => doesAddressMatch(address, query.toLowerCase()));
                $scope.$apply();
            }

            function selectAddress(address){
                $element.get(0).dispatchEvent(new CustomEvent(ADDRESS_SELECTED_EVENT, {detail: address}));
            }

            function doesAddressMatch(address, query) {
                return getOrDefault(address?.companyAddressWithContact?.companyAddress.companyName?.line1, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.companyName?.line2, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.street, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.zip, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.city, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.address?.state, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.emailAddress?.value, '').includes(query) ||
                    getOrDefault(address?.companyAddressWithContact?.companyAddress.emailAddress?.value, '').includes(query) ||
                    getOrDefault(`${address?.companyAddressWithContact?.personName.firstname} ${address?.companyAddressWithContact?.personName.lastname}`, '').includes(query) ||
                    getOrDefault(`${address?.companyAddressWithContact?.personName.lastname}, ${address?.companyAddressWithContact?.personName.firstname}`, '').includes(query) ||
                    translateCountry(address?.companyAddressWithContact?.companyAddress.address?.country, $scope.user.language.iso639LanguageAlpha2).includes(query)
            }

            function getOrDefault(property, defaultValue) {
                return property ? property.toLowerCase() : defaultValue.toLowerCase();
            }

        }
    };
};
